import { render, staticRenderFns } from "./PageBatchDetail.vue?vue&type=template&id=2e899df6&scoped=true"
import script from "./PageBatchDetail.vue?vue&type=script&lang=js"
export * from "./PageBatchDetail.vue?vue&type=script&lang=js"
import style0 from "./PageBatchDetail.vue?vue&type=style&index=0&id=2e899df6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e899df6",
  null
  
)

export default component.exports